module.exports = __webpack_public_path__ + "static/media/arrows_up.9876397c.svg";